import toast from '../toast'
import Swal from '../sweetalert'
import parseValidationError from './parse-validation-error'

const setupErrorHandler = () => {
    window.axios.interceptors.response.use(
        response => response, errorResponseHandler
    )
}

const errorResponseHandler = (error) => {
    // check for errorHandle config
    let hasBarProperty = Object.prototype.hasOwnProperty.call(error.config, 'errorHandle')
    if (hasBarProperty && error.config.errorHandle === false) {
        return Promise.reject(error)
    }

    // if has response show the error
    let response = error.response
    if (response) {
        let errors
        let title = response.title

        if (response.status === 422) {
            errors = parseValidationError(response.data.errors)
        } else {
            errors = [response.data.message || response.statusText]
            title = 'Aj een fout!'
        }

        if (window.location.pathname.match('^/admin')) {
            toast.error(errors.join('<br>'), title)
        } else {
            Swal.fire({
                title,
                html: errors.join('<br>'),
                icon: 'warning',
            })
        }
    }

    return Promise.reject(error)
}

export function load () {
    setupErrorHandler()
}
